/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { SdiLicense, SdiHeart, styles } from '@sdir/sds';
import { routes } from '../../../constants/routes';
import { useNavigateWithLang } from '../../../services/hooks/useNavigateWithLang';

const HomePage: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigateWithLang();

  const navigateToPage = (route: string) => {
    navigate(route);
  };

  return (
    <Section>
      <MenuPanel>
        <NavCard
          onClick={() => navigateToPage(routes.certificateSearch)}
          role="link"
          tabIndex={0}
          onKeyUp={(e) => e.key === 'Enter' && navigateToPage(routes.certificateSearch)}
        >
          <Tile>
            <SdiLicense color={styles.colors.primary} size="m" />
            <h2>{intl.formatMessage({ id: 'certificate.title' })}</h2>
            <span>{intl.formatMessage({ id: 'certificate.desc' })}</span>
          </Tile>
        </NavCard>
        <NavCard
          onClick={() => navigateToPage(routes.endorsementSearch)}
          role="link"
          tabIndex={0}
          onKeyUp={(e) => e.key === 'Enter' && navigateToPage(routes.endorsementSearch)}
        >
          <Tile>
            <SdiLicense color={styles.colors.primary} size="m" />
            <h2>{intl.formatMessage({ id: 'endorsement.title' })}</h2>
            <span>{intl.formatMessage({ id: 'endorsement.desc' })}</span>
          </Tile>
        </NavCard>
        <NavCard
          onClick={() => navigateToPage(routes.dispensationSearch)}
          role="link"
          tabIndex={0}
          onKeyUp={(e) => e.key === 'Enter' && navigateToPage(routes.dispensationSearch)}
        >
          <Tile>
            <SdiLicense color={styles.colors.primary} size="m" />
            <h2>{intl.formatMessage({ id: 'dispensation.title' })}</h2>
            <span>{intl.formatMessage({ id: 'dispensation.desc' })}</span>
          </Tile>
        </NavCard>
        <NavCard
          onClick={() => navigateToPage(routes.sidSearch)}
          role="link"
          tabIndex={0}
          onKeyUp={(e) => e.key === 'Enter' && navigateToPage(routes.sidSearch)}
        >
          <Tile>
            <SdiLicense color={styles.colors.primary} size="m" />
            <h2>{intl.formatMessage({ id: 'sid.title' })}</h2>
            <span>{intl.formatMessage({ id: 'sid.desc' })}</span>
          </Tile>
        </NavCard>
        <NavCard
          onClick={() => navigateToPage(routes.healthSearch)}
          role="link"
          tabIndex={0}
          onKeyUp={(e) => e.key === 'Enter' && navigateToPage(routes.healthSearch)}
        >
          <Tile>
            <SdiHeart color={styles.colors.primary} size="m" />
            <h2>{intl.formatMessage({ id: 'health.title' })}</h2>
            <span>{intl.formatMessage({ id: 'health.desc' })}</span>
          </Tile>
        </NavCard>
      </MenuPanel>
    </Section>
  );
};

export default HomePage;

const Section = styled.section`
  margin: 0 auto;
  padding: 30px 0;
`;

const NavCard = styled.article`
  position: relative;
  padding: 1px;
  cursor: pointer;
`;

const MenuPanel = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.screen.large}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: ${({ theme }) => theme.screen.medium}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const Tile = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 2rem;
  width: 100%;
  height: 100%;
  padding: 30px;
  border: 1px solid #d6dce2;
  border-radius: ${({ theme }) => theme.card.borderRadius};
  background-color: ${({ theme }) => theme.colors.background.secondary};

  &:hover {
    box-shadow: ${({ theme }) => theme.card.boxShadow};
  }

  h2 {
    color: ${({ theme }) => theme.colors.primary};
  }

  span {
    color: ${({ theme }) => theme.colors.font.text85};
  }
`;
